import { MONTH_LABELS } from '../constants/modeGraphicConstants';

export const hexToRgba = (hex, opacity) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const formatMonthLabel = (value) => {
  if (typeof value !== 'string') return value;

  const [year, month] = value.split('-');
  const monthIndex = Number(month) - 1;
  if (!year || Number.isNaN(monthIndex)) return value;

  return `${MONTH_LABELS[monthIndex] || month}/${year.slice(-2)}`;
};

export const formatMetricValue = (value) =>
  new Intl.NumberFormat('pt-BR').format(value || 0);

export const normalizeStatus = (status) => String(status || '').replace(/^total_/, '');
